import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@mui/material/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Button from '@mui/material/Button';
import { Grid } from "@material-ui/core";
import { switchChatAgent } from "../../actions/OffLineSupportActions";

let width = window.innerWidth;
let isMobile = width <= 500;

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "scroll",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: isMobile ? "400px" : "800px",
    maxHeight: "600px",
    overflow: "scroll",
    position: "sticky",
  },
  head: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "2rem",
  },
}));

type ModalProps = {
  setOpenReportModel1: Function;
  openReportModel1: any;
  setLeadId: any;
  leadId: any;
  switchChatAgent: any;
  lastMessageId: any;
};

const CommentsModal2: React.FC<ModalProps> = ({
  setOpenReportModel1,
  openReportModel1,
  setLeadId,
  leadId,
  switchChatAgent,
  lastMessageId,
}) => {
  const classes = useStyles();
  const [checkedWay, setCheckedWay] = useState<any>("");

  const handleClose = () => {
    setOpenReportModel1(false);
    setCheckedWay("");
  };

  useEffect(() => {
    if (openReportModel1 === false) {
      setCheckedWay("")
    }
  }, [openReportModel1])

  const handleSwitchChat = async () => {
    const body: any = {
        skill: checkedWay === "sales" ? "sales" : "cs",
    }
    await switchChatAgent(leadId, lastMessageId, body);
    setOpenReportModel1(false);
  };

  const handleCancelSwitchChat = () => {
    setOpenReportModel1(false)
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={openReportModel1}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={openReportModel1}>
        <div className={classes.paper}>
          <>
            <h3 style={{ marginLeft: "14px" }}>Switch Chat Agent</h3>
            <Grid container spacing={3} style={{ margin: "0px" }}>
              <Grid item xs={12} style={{ margin: "0px" }}>
              <div className="checkList" style={{ display: "flex" }}>
                <div style={{ fontSize: "large", fontWeight: "bolder" }}>Switch Chat To:</div>
                <div style={{ display: "flex" }}>
                  <div style={{ paddingLeft: "20px" }}>
                    <input value={"cs"} type="checkbox" checked={checkedWay === "cs" ? true : false} onChange={(e) => {!e.target.checked ? setCheckedWay("") : setCheckedWay(e.target.value);}} />
                    <span style={{ paddingLeft: "4px" }}>SUPPORT EXECUTIVE</span>
                  </div>
                  <div style={{ paddingLeft: "20px" }}>
                    <input value={"sales"} type="checkbox" checked={checkedWay === "sales" ? true : false} onChange={(e) => {!e.target.checked ? setCheckedWay("") : setCheckedWay(e.target.value);}} />
                    <span style={{ paddingLeft: "4px" }}>SALES</span>
                  </div>
                </div>
              </div>
              </Grid>
              <Button
                variant="contained"
                style={{
                  marginTop: "20px",
                  marginLeft: "14px",
                }}
                color="primary"
                onClick={() => handleSwitchChat()}
                disabled={checkedWay === ""}
              >
                PROCEED
              </Button>
              <Button
                variant="contained"
                style={{
                  marginTop: "20px",
                  marginLeft: "14px",
                }}
                color="secondary"
                onClick={handleCancelSwitchChat}
              >
                Cancel
              </Button>
            </Grid>
          </>
        </div>
      </Fade>
    </Modal>
  );
};

const mapStateToProps = (state: any) => ({
});

export default connect(mapStateToProps, {
  switchChatAgent,
})(CommentsModal2);
